export default __webpack_public_path__ + "static/media/char-r2d2.28d1ce3b.jpg";